import {
  APPLICATIONS,
  APPLICATIONS_LINK_MAP,
  APPLICATIONS_LINK_MAP_V2,
} from '~/components/ApplicationUrls';

export const ADMIN_REORG_REDIRECTION_CONFIG = {
  //Training routes redirection
  [APPLICATIONS_LINK_MAP[APPLICATIONS.ADMIN_DASHBOARD].url]:
    APPLICATIONS_LINK_MAP_V2[APPLICATIONS.ADMIN_DASHBOARD].url,
  'new/ui/admin/programs': 'new/ui/training/programs',
  'new/ui/admin/program/*': 'new/ui/training/program/*',
  'new/ui/admin/archive': 'new/ui/training/archive',
  'new/ui/admin/archive/*': 'new/ui/training/archive/*',
  'new/ui/admin/search': 'new/ui/training/search',
  'new/ui/admin/search/*': 'new/ui/training/search/*',
  'new/ui/admin/scheduled-invitation': 'new/ui/training/scheduled-invitation',
  'new/ui/admin/scheduled-invitation/*': 'new/ui/training/scheduled-invitation/*',
  'new/ui/admin/templates': 'new/ui/training/templates',
  'new/ui/admin/templates/*': 'new/ui/training/templates/*',
  //Users routes redirection
  [APPLICATIONS_LINK_MAP[APPLICATIONS.LEARNERS_URL].url]:
    APPLICATIONS_LINK_MAP_V2[APPLICATIONS.LEARNERS_URL].url,
  [`${APPLICATIONS_LINK_MAP[APPLICATIONS.LEARNERS_URL].url}/*`]: `${
    APPLICATIONS_LINK_MAP_V2[APPLICATIONS.LEARNERS_URL].url
  }/*`,
  //Profile management redirection
  [APPLICATIONS_LINK_MAP[APPLICATIONS.PROFILE_MANAGEMENT].url]:
    APPLICATIONS_LINK_MAP_V2[APPLICATIONS.PROFILE_MANAGEMENT].url,
  [`${APPLICATIONS_LINK_MAP[APPLICATIONS.PROFILE_MANAGEMENT].url}/*`]: `${
    APPLICATIONS_LINK_MAP_V2[APPLICATIONS.PROFILE_MANAGEMENT].url
  }/*`,
  //Manage certificates redirection
  'new/ui/manage-certificates': 'new/ui/training/certificates',
  [`${APPLICATIONS_LINK_MAP[APPLICATIONS.MANAGE_CERTIFICATES].url}/*`]: `${
    APPLICATIONS_LINK_MAP_V2[APPLICATIONS.MANAGE_CERTIFICATES].url
  }/*`,
  //Tags redirection
  'new/ui/tags': 'new/ui/training/tags',
  'new/ui/tags/*': 'new/ui/training/tags/*',
};

export const LEARNER_REORG_REDIRECTION_CONFIG = {
  // coaching and mission dashboard redirections
  'new/ui/learner/coaching-dashboard': 'new/ui/learner/review/coaching-dashboard',
  'new/ui/learner/coaching-dashboard/*': 'new/ui/learner/review/coaching-dashboard/*',
  'new/ui/learner/mission-dashboard': 'new/ui/learner/review/mission-dashboard',
  'new/ui/learner/mission-dashboard/*': 'new/ui/learner/review/mission-dashboard/*',
  [APPLICATIONS_LINK_MAP[APPLICATIONS.LEARNER_READINESS_PROGRAMS].url]:
    APPLICATIONS_LINK_MAP_V2[APPLICATIONS.LEARNER_READINESS_PROGRAMS].url,
  [`${[APPLICATIONS_LINK_MAP[APPLICATIONS.LEARNER_READINESS_PROGRAMS].url]}/*`]: `${
    APPLICATIONS_LINK_MAP_V2[APPLICATIONS.LEARNER_READINESS_PROGRAMS].url
  }/*`,
  [APPLICATIONS_LINK_MAP[APPLICATIONS.MODULE_LIBRARY].url]:
    APPLICATIONS_LINK_MAP_V2[APPLICATIONS.MODULE_LIBRARY].url,
  [APPLICATIONS_LINK_MAP[APPLICATIONS.LEARNER_PEERS].url]:
    APPLICATIONS_LINK_MAP_V2[APPLICATIONS.LEARNER_PEERS].url,
  [`${APPLICATIONS_LINK_MAP[APPLICATIONS.CONTENT_MEDIA_VOSS].url}/sme`]: APPLICATIONS_LINK_MAP_V2[
    APPLICATIONS.TASKS
  ].url,
  [`${[APPLICATIONS_LINK_MAP[APPLICATIONS.LEARNER_PEERS].url]}/*`]: `${
    APPLICATIONS_LINK_MAP_V2[APPLICATIONS.LEARNER_PEERS].url
  }/*`,
};
